import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Menu18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M16 4.75H2V3.25H16V4.75Z' fill='currentColor' />
    <path d='M16 9.75H2V8.25H16V9.75Z' fill='currentColor' />
    <path d='M2 14.75H16V13.25H2V14.75Z' fill='currentColor' />
  </Svg>
);

Menu18.displayName = 'Menu18';
export default Menu18;
